/**Packages */
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

/**Helpers */
import { getRandomString } from "../../../helpers/utils";

/**CSS */
import "./style.css";

const Textarea = ({
  type = "text",
  name = "",
  value = "",
  placeholder = "",
  required = false,
  disabled = false,
  readonly = false,
  withError = false,
  hideError = false,
  options = [],
  validIf = [],
  rows = 5,
  errorMessage = "Errore!!!",
  id = `floating-input-${name}-${(Math.random() + 1).toString(36).substring(5)}`,
  classList = "",
  onFocus = () => { },
  onBlur = () => { },
  onChange = (e) => { },
  children
}) => {
  const [isActive, setIsActive] = useState(false);
  const [inputType, setInputType] = useState(type);
  const [togglePasswordClass, setTogglePasswordClass] = useState(faEye);

  function handleTextChange(e, currentValue) {
    if (currentValue !== "") {
      setIsActive(true);
    } else {
      setIsActive(false);
    }

    onChange(e, currentValue);
  }

  function getIsActive() {
    return isActive || value !== "";
  }

  const togglePassword = (e) => {
    e.preventDefault();

    if (inputType === "password") {
      setInputType("text");
      setTogglePasswordClass(faEyeSlash);
    } else {
      setInputType("password");
      setTogglePasswordClass(faEye);
    }
  };

  const classes = `float-label float-textarea floating-input-${name} ${classList} ${withError && "with-error"}`;

  return (
    <div className={classes}>
      <textarea
        id={id}
        rows={rows}
        name={name}
        onChange={onChange}
        value={value}
      >
      </textarea>

      <div className={`error-message ${!!hideError && 'hidden'}`}>{errorMessage}</div>
      <label className={getIsActive() ? "active" : ""} htmlFor={type}>
        {placeholder}
      </label>
    </div>
  );
};

export default Textarea;
